import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./paginas/principal/home";
import Login from "./paginas/principal/login";
import Cobranca from "./paginas/cobranca/index.jsx";
import Venda from "./paginas/venda/index.jsx";
import Estoque from "./paginas/estoque/index.jsx";
import Footer from "./componente/footer";
import PrivateRoute from "./componente/PrivateRoute"; // novo componente

function App() {
  return (
    <>      
      <BrowserRouter>      
      <Routes>
        <Route path="/" element={<Login />}/>
        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute> } />                                     
        <Route path="/cobranca" element={<PrivateRoute><Cobranca /></PrivateRoute> } />   
        <Route path="/venda" element={<PrivateRoute><Venda /></PrivateRoute> } />  
        <Route path="/estoque" element={<PrivateRoute><Estoque /></PrivateRoute> } /> 
      </Routes>      
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;
